export {FileInputComponent} from './file-input.component';



// WEBPACK FOOTER //
// ./src/app/shared/forms/input/file-input/index.ts